import React, { useState, useContext, useEffect } from 'react'
import { Label, Select, SelectOption } from '@americanexpress/dls-react'
import UserContext from '../ContextComponent/UserContext';

function Citizenship() {
    const { formData, setFormData } = useContext(UserContext);
    const [options, setOptions] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetch(`/api/content/Countries/CountryCode`)
                .then(response => response.json())
                .then(json => JSON.parse(json[0].value));

            setOptions(() => result.map(option => <SelectOption key={option.ccn3} id={option.ccn3} value={option.cca2}>{option.country}</SelectOption>))
        }
        fetchData();
    }, []);

    const handleOnChange = (event) => {
        setFormData({ ...formData, citizenship: event.target.value });
    }



    return (
        <div>
            <Label htmlFor="Citizenship" className="label-1">Citizenship</Label>
            <Select id="Citizenship" value={formData.citizenship} name="Citizenship" fluid={true} onChange={handleOnChange}>
                {options}
            </Select>
        </div>
    );
}

export default Citizenship;